import React from 'react';

import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './ProgramSetItemSkeleton.styles';

const ProgramSetItemSkeleton = () => {
  const theme = useTheme();

  const { classes } = useStyles(theme);

  return (
    <div className={classes.wrapper}>
      <Box className={classes.leftBlock}>
        <Skeleton
          variant="text"
          className={classes.titleSkeleton}
          height={22}
          width="70%"
        />
        <Skeleton
          variant="text"
          className={classes.subtitleSkeleton}
          height={18}
          width="50%"
        />
      </Box>
      <Box className={classes.iconsBlock}>
        <Skeleton
          variant="circular"
          className={classes.iconSkeleton}
          width={24}
          height={24}
        />
        <Skeleton
          variant="circular"
          className={classes.iconSkeleton}
          width={24}
          height={24}
        />
      </Box>
    </div>
  );
};

export default ProgramSetItemSkeleton;
